import axios from 'axios';

export const SERVICE_CAPTCHA_BASE_URL = process.env.GATSBY_BASE_URL;
export const URL_CAPTCHA_IMAGE = '/PrimaWeb/kaptcha.jpg';
export const SERVICE_CAPTCHA_VERIFY = '/PrimaWeb/zona-informativa/kaptcha';

export default axios.create({
  baseURL: SERVICE_CAPTCHA_BASE_URL,
  responseType: 'json',
});
